import { ValidatorFn, AbstractControl } from '@angular/forms';
import { Utils } from '../libs';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || !control.value) {
      return null;
    }

    return Utils.passwordValidate(control.value) ? null : { password: false };
  };
}
